export default "__VITE_ASSET__WdV3PMXY__"